import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceOrder($orderReference: ID!, $cartId: UUID!) {
    marketplaceOrder(orderReference: $orderReference, cartId: $cartId) {
      orderReference
      status
      totalIncTax
      totalTax
      payment {
        cardType
        last4
      }
      billingAddress {
        firstName
        lastName
        email
        phone
        address1
        suburb
        state
        postCode
        country
      }
      shippingAddress {
        address1
        suburb
        state
        postCode
      }
      parcels {
        fulfilmentType
        fulfilmentLocation
        fulfilmentDayRange {
          min
          max
        }
        centre {
          title
          physicalAddress
          suburb
          state
          postcode
        }
        centreTitle
        centreServicePageURL
        shippingCost
        items {
          id
          name
          quantity
          shop {
            retailer {
              sys {
                id
              }
            }
            id
            name
          }
          quantity
          priceIncTax
          variant {
            sku
            returnable
            category {
              title
              path {
                title
              }
            }
            optionValues {
              id
              optionId
              displayName
              value
            }
            title
            brand
            variantGroupCode
            price
            originalPrice
            discountPrice
            images {
              url
              description
            }
          }
        }
      }
    }
  }
`
